<template>
  <vue100vh style="position: fixed;width: 100%;">
  <div class="CSChatThai BGwhite">
    <v-toolbar style="background-color: white !important;">
      <v-btn icon @click="toPage()">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <v-toolbar-title>{{$t('Dialog.wallpaper.headerWallpaper')}}</v-toolbar-title>
    </v-toolbar>
    <v-card-text style="overflow-y: scroll; height: calc(100vh - 128px); overflow-x: hidden;">
      <!-- <v-container grid-list-md> -->
        <v-layout wrap align-center>
          <v-layout column wrap justify-center align-center>
            <vue-avatar
              :image="imageData"
              :width="450"
              :height="450"
              :rotation="rotation"
              :scale="scale"
              :border="0"
              ref="vueavatar"
              @vue-avatar-editor:image-ready="onImageReady"
              style="border: solid thin #eee; height: 300px; margin-bottom: 10px;  background-size: 100px, 100px, cover; background-position: center;"
            >
          </vue-avatar>
            <br>
            <v-slider
              v-model="scale"
              label="Zoom :"
              min=1
              max=3
              step=0.02
              thumb-label="always"
              ticks
            ></v-slider>
            <v-slider
              v-model="rotation"
              label="Rotation :"
              min=0
              max=360
              step=1
              thumb-label="always"
              ticks
            ></v-slider>
          </v-layout>
          <v-layout row wrap justify-center align-center>
            <v-btn @click="saveClicked()" class="btnwallpaper text-transform" :disabled="!check">{{$t('AnswerQuestion.setbackground')}}</v-btn>
            <v-btn @click="resetbg()"class="btnresetwallpaper text-transform">{{$t('AnswerQuestion.resetbackground')}}</v-btn>
          </v-layout>
        </v-layout>
      <!-- </v-container> -->
    </v-card-text>
  </div>
</vue100vh>
</template>
<script>
import { Momenttime, Decode } from '@/services'
import { VueAvatar } from 'vue-avatar-editor-improved'
import { sync } from 'vuex-pathify'
import vue100vh from 'vue-100vh'
var _ = require('lodash')
export default {
  data () {
    return {
      rotation: 0,
      scale: 1,
      tokenuser: '',
      tokenroom: '',
      imageData: '',
      wallpaperInfo: {
        info:
        [
          {
            room: '',
            background: ''
          }
        ]
      },
      check: false,
      img: 'https://image.flaticon.com/icons/png/512/118/118246.png',
      canvasWidth: 0,
      canvasHeight: 0
    }
  },
  components: {
    VueAvatar,
    vue100vh
  },
  computed: {
    ...sync('*')
  },
  watch: {
    '$route.params.roomid' () {
      var canvas = document.getElementById('avatarEditorCanvas')
      var context = canvas.getContext('2d')
      context.clearRect(0, 0, canvas.width, canvas.height)
      if (JSON.parse(localStorage.getItem('wallpaperInfo')) === null) {
        localStorage.setItem('wallpaperInfo', JSON.stringify(this.wallpaperInfo))
      }
    }
  },
  created() {
    var decoded = JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.tokenuser = decoded['tokenuser']
    this.tokenroom = this.$route.params.roomid
  },
  methods: {
    resetbg () {
      this.$swal({
        type: 'warning',
        text: this.$t('Alert.Right.removeWallpaper'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#999999',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        buttonsStyling: true,
        showCloseButton: true,
        showCancelButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          var wallpaper = JSON.parse(localStorage.getItem('wallpaperInfo'))
          var room = this.$route.params.roomid
          var index = _.findIndex(wallpaper.info, function (o) { return o.room === room })
          wallpaper.info.splice(index, 1)
          localStorage.setItem('wallpaperInfo', JSON.stringify(wallpaper))
          this.$swal('', this.$t('Alert.Success.deletebackground'), 'success')
          this.chat_wallpaper = JSON.parse(localStorage.getItem('wallpaperInfo'))
          this.closeDialog()
        }
      })
    },
    saveClicked () {
      const vm = this
      const canvas = this.$refs.vueavatar.getImageScaled()
      canvas.toBlob(function(blob){
        const reader = new FileReader()
        reader.onload = (e) => {
          vm.imageData = e.target.result
          vm.setbg(vm.imageData)
        }
        reader.readAsDataURL(blob)
      })
    },
    onImageReady () {
      // var canvas = document.getElementById('avatarEditorCanvas')
      // var context = canvas.getContext('2d')
      // context.clearRect(0, 0, canvas.width, canvas.height)
      this.check = true
      this.scale = 1
      this.rotation = 0
    },
    setbg (img) {
      this.imageData = img
      var wallpaper = JSON.parse(localStorage.getItem('wallpaperInfo'))
      var room = this.$route.params.roomid
      var index = _.findIndex(wallpaper.info, function (o) { return o.room === room })
      if (index === -1) {
        wallpaper.info.push({
          room:  this.$route.params.roomid,
          background: this.imageData
        })
        localStorage.setItem('wallpaperInfo', JSON.stringify(wallpaper))
      } else {
        wallpaper.info.splice(index, 1)
        wallpaper.info.push({
          room:  this.$route.params.roomid,
          background: this.imageData
        })
        localStorage.setItem('wallpaperInfo', JSON.stringify(wallpaper))
      }
      this.imageData = ''
      this.$swal('', this.$t('Alert.Success.setbackground'), 'success')
      // this.closeDialog()
      this.chat_wallpaper = JSON.parse(localStorage.getItem('wallpaperInfo'))
      this.$router.push('/mobile/room/' + this.$route.params.roomid)
    },
    closeDialog () {
      // console.log(this.imageData)
      // this.canvasWidth = 0
      // this.canvasHeight = 0
      var canvas = document.getElementById('avatarEditorCanvas')
      var context = canvas.getContext('2d')
      context.clearRect(0, 0, canvas.width, canvas.height)
      this.$refs.vueavatar.state.image.resource = null
      this.check = false
      this.scale = 1
      this.rotation = 0
      this.imageData = ''
      this.$emit('closeWallpaper', false)
    },
    toPage () {
      // this.$router.go(-1)
      this.$router.push('/mobile/room/' + this.$route.params.roomid)
    }
  }
}
</script>
<style lang="css" scoped>
.text-transform {
  text-transform: none;
}
>>>.v-toolbar__title {
  margin-left: 0px !important;
}
.btnwallpaper {
  background-color: #2196f3 !important;
  color: white !important;
  border-style: solid !important;
  border-width: thin !important;
  border-radius: 7px !important;
  width: 117px !important;
  box-shadow: none !important;
  /* border-color: #3896f3 !important; */
}
.btnresetwallpaper {
  background-color: #ffff !important;
  color: #3896f3 !important;
  border-style: solid !important;
  border-width: thin !important;
  border-radius: 7px !important;
  width: 117px !important;
  border-color: #3896f3 !important;
  box-shadow: none !important;
}

.preview {
  width: 300px;
  height: 300px;
  object-fit: cover;
  object-position: 50% 0;
}
.btnalbums {
  width: 100px !important;
  border-style: solid !important;
  border-radius: 20px !important;
  border-width: thin !important;
  border-color: inherit !important;
  background-color: #2196f3 !important;
  color: white !important;
  text-transform: none;
}
>>>.v-dialog .v-dialog--active .v-dialog--persistent {
  border-radius: 20px !important;
}
>>>.v-list .v-list--two-line .theme--light {
  width: 100% !important;
}


#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/manage/Wallpaper.vue